<template>
  <div style="height: 79vh; overflow-y: scroll">
    <div class="mt-3 mb-4">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-9">
              <h3 class="pt-2 mb-0">
                <b>Welcome {{ user.name.split(" ")[0] }} 👋</b>
              </h3>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <button
                class="btn btn-primary float-right btn-block"
                data-toggle="modal"
                data-target="#channelName"
              >
                Create Event
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="card-counter primary">
          <i class="fas fa-bullhorn"></i>
          <span class="count-numbers">{{ counter.meetFast }}</span>
          <span class="count-name">Quick Event</span>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card-counter danger">
          <i class="fas fa-ticket-alt"></i>
          <span class="count-numbers">{{ counter.attended }}</span>
          <span class="count-name">Attended Events</span>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card-counter success">
          <i class="fas fa-user-check"></i>
          <span class="count-numbers">{{ counter.invited }}</span>
          <span class="count-name">Invited</span>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card-counter info">
          <i class="fas fa-user-clock"></i>
          <span class="count-numbers">{{ events.length }}</span>
          <span class="count-name">Upcoming event</span>
        </div>
      </div>
    </div>
    <div class="mt-5 mb-4" v-if="quickEvents.length > 0">
      <hr />
      <h5 class="mb-4">
        <b>Your Quick Events <small>(last 10 meets)</small></b>
      </h5>
      <div
        class="data-scroll"
        style="width: auto;overflow: auto hidden;white-space: nowrap;"
      >
        <div class="mr-2">
          <div
            style="width: 300px;height:120px;;margin-right: 10px;display: inline-block;"
            v-for="(e, i) in quickEvents"
            :key="i"
            class="quick-event"
          >
            <div class="card">
              <div class="row">
                <div class="col-5" style="padding:0 12px">
                  <figure
                    :data-user="e.title.charAt(0).toUpperCase()"
                    :style="
                      'border-radius: 12px 0 0 12px;font-weight: bold;margin: 0;background:#000'
                    "
                  ></figure>
                  <!--									<img v-if="e.image" :src="e.image" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">-->
                  <!--									<img src="../../../public/img/icons/logo-192x192.png" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%; padding: 20px;">-->
                  <div
                    class="bg-success"
                    id="HST"
                    v-if="e.role === 'host'"
                    style="right: 12px"
                  >
                    <span style="margin-top: 6px; color: #000;">HST</span>
                  </div>
                  <div
                    class="bg-info"
                    id="SPK"
                    v-else-if="e.role === 'speaker'"
                    style="right: 12px"
                  >
                    <span style="margin-top: 6px">SPK</span>
                  </div>
                  <div class="bg-warning" id="ATT" v-else style="right: 12px">
                    <span style="margin-top: 6px">ATT</span>
                  </div>
                </div>
                <div class="col-7">
                  <h5 class="mb-0 mt-1">
                    {{
                      e.title.length >= 12
                        ? e.title.substr(0, 12) + ".."
                        : e.title.toUpperCase()
                    }}
                  </h5>
                  <p style="font-size: 12px" class="text-muted mb-0">
                    {{ e.created_at | moment("from", "now") }}
                  </p>
                  <div style="margin-right: 5px; margin-bottom: 5px;">
                    <a
                      :href="'/event/' + e.title + '/' + e.event_id"
                      target="_blank"
                      class="btn btn-primary btn-sm link"
                    >
                      <b style="margin-right: 10px">Enter</b>
                      <i class="fas fa-door-open"></i>
                    </a>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary ml-2"
                      data-toggle="modal"
                      data-target="#recordingModal"
					            @click="setChannelId(e.event_id)"
                    >
                      Recs
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--			<div  class="bg-black">-->
      <!--				<div class="text-center mt-4 mb-2">-->
      <!--					<h5 class="card-title">No User added</h5>-->
      <!--					<p class="card-text">Enter the email address.</p>-->
      <!--					<a href="#" class="btn btn-primary">Invite</a>-->
      <!--				</div>-->
      <!--			</div>-->
    </div>
    <div class="mt-3 mb-4" v-if="events.length > 0">
      <hr />
      <h5><b>Upcoming Scheduled Events</b></h5>
      <div class="data-scroll">
        <div class="row">
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-4 mt-2 mb-2"
            v-for="(e, i) in events"
            :key="i"
          >
            <div class="card">
              <!--							<div class="row">-->
              <!--								<div class="col-5">-->
              <!--									<img v-if="e.image" :src="e.image" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">-->
              <!--									<img v-else src="../../assets/verify.png" style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 100%;">-->
              <!--									<div class="bg-success" id="HST" v-if="e.role==='host'"><span style="margin-top: 6px">HST</span></div>-->
              <!--									<div class="bg-info" id="SPK" v-else-if="e.role==='speaker'"><span style="margin-top: 6px">SPK</span></div>-->
              <!--									<div class="bg-warning" id="ATT" v-else><span style="margin-top: 6px">ATT</span></div>-->
              <!--								</div>-->
              <!--								<div class="col-7">-->
              <!--									<h5 class="mb-0 mt-1">{{e.title.length >= 12 ? e.title.substr(0, 12) + '..' : e.title.toUpperCase()}}</h5>-->
              <!--									<p class="text-white mb-0" style="font-size: 12px;"  v-if="e.status === 'Live'" ><span class="bg-danger" style="border-radius: 2px;padding: 0 2px">Live</span></p>-->
              <!--									<p style="font-size: 12px" v-else class="text-muted mb-0">{{e.start_date | moment("from", "now")}}</p>-->
              <!--									<div style="margin-right: 5px; margin-bottom: 5px">-->
              <!--										<a :href="'https://meetbeans.com/e/' + e.event_id" target="_blank" class="btn btn-primary btn-sm">-->
              <!--											<b style="margin-right: 10px">Enter</b>-->
              <!--											<i class="fas fa-door-open"></i>-->
              <!--										</a>-->
              <!--										<a class="btn btn-secondary btn-sm" title="Calender" style="border-radius: 25px; margin-left: 2px;" target="_blank" :href="'https://calendar.google.com/calendar/r/eventedit?text='+ e.title +'&dates=' + e.calendar_start  +'/' + e.calendar_end +'&details=For+details,+link+here:+https://meetbeans.com/e/' + e.event_id + '&location=meetbeans.com'">-->
              <!--										<span>-->
              <!--											<i class="fas fa-calendar-week"></i>-->
              <!--										</span>-->
              <!--										</a>-->
              <!--									</div>-->
              <!--								</div>-->
              <!--							</div>-->
              <img
                v-if="e.image"
                :src="e.image"
                style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 12px 0 0; width: 100%; height: 150px;"
              />
              <img
                v-else
                src="../../assets/verify.png"
                style="float: left; margin-right: 5px; object-fit: cover; border-radius: 12px 0 0 12px; width: 100%; height: 150px;"
              />
              <div class="bg-success" id="HST" v-if="e.role === 'host'">
                <span style="margin-top: 6px;color: #000;">HST</span>
              </div>
              <div class="bg-info" id="SPK" v-else-if="e.role === 'speaker'">
                <span style="margin-top: 6px">SPK</span>
              </div>
              <div class="bg-warning" id="ATT" v-else>
                <span style="margin-top: 6px">ATT</span>
              </div>
              <div class="card-body">
                <h5 class="mb-0 mt-1" style="font-family: 'Vidaloka', serif;">
                  {{
                    e.title.length >= 20
                      ? e.title.substr(0, 20) + ".."
                      : e.title
                  }}
                </h5>
                <p
                  class="text-white mb-0"
                  style="font-size: 12px;"
                  v-if="e.status === 'Live'"
                >
                  <span
                    class="bg-danger"
                    style="border-radius: 2px;padding: 0 2px"
                    >Live</span
                  >
                </p>
                <p style="font-size: 12px" v-else class="text-muted mb-0">
                  {{ e.start_date | moment("from", "now") }}
                </p>
                <div style="margin-right: 5px; margin-bottom: 5px">
                  <a
                    :href="'/e/' + e.event_id"
                    target="_blank"
                    class="btn btn-primary btn-sm"
                  >
                    <b style="margin-right: 10px">Enter</b>
                    <i class="fas fa-door-open"></i>
                  </a>
                  <a
                    class="btn btn-secondary btn-sm"
                    title="Calender"
                    style="border-radius: 25px; margin-left: 2px;"
                    target="_blank"
                    :href="
                      'https://calendar.google.com/calendar/r/eventedit?text=' +
                        e.title +
                        '&dates=' +
                        e.calendar_start +
                        '/' +
                        e.calendar_end +
                        '&details=For+details,+link+here:+https://meetbeans.com/e/' +
                        e.event_id +
                        '&location=meetbeans.com'
                    "
                  >
                    <span>
                      <i class="fas fa-calendar-week"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--			<div  class="bg-black">-->
      <!--				<div class="text-center mt-4 mb-2">-->
      <!--					<h5 class="card-title">No User added</h5>-->
      <!--					<p class="card-text">Enter the email address.</p>-->
      <!--					<a href="#" class="btn btn-primary">Invite</a>-->
      <!--				</div>-->
      <!--			</div>-->
    </div>
    <div class="mt-3 mb-4" v-else>
      <div class="text-center">
        <svg
          width="250"
          height="250"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <image
            href="../../assets/calendar.svg"
            style="color: #fbaf28 !important;"
            width="250"
            height="250"
          />
        </svg>
        <p>
          To organize an event, first thing first you have to create an
          organization <br />
          and then you can create an event.
        </p>
        <button
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#organisation"
        >
          New Organisation
        </button>
      </div>
    </div>
    <div class="mt-3 mb-4" v-if="tutorials.length > 0">
      <hr />
      <h5><b>Tutorials</b></h5>
      <div class="bg-black">
        <div class="row">
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2 mb-2"
            v-for="(t, i) in tutorials"
            :key="i"
          >
            <div
              class="card"
              @click="setTutorial(t)"
              data-toggle="modal"
              data-target="#tutorials"
              style="cursor: pointer"
            >
              <div class="position-relative">
                <img
                  :src="t.image"
                  class="rounded img-fluid mx-auto d-block"
                  alt=""
                  id="play-video"
                />
                <div class="play-icon">
                  <i
                    class="fas fa-play-circle"
                    style="font-size: 80px;"
                    id="play-video-svg"
                  ></i>
                </div>
              </div>
              <!--							<iframe width="100%" height="200px" :src="'https://www.youtube.com/embed/' + t.link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div class="card-body text-center">
                <p>{{ t.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="tutorials"
      tabindex="-1"
      role="dialog"
      aria-labelledby="video"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ tutorial.title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" id="close-video" @click="closeTutorial()"
                >&times;</span
              >
            </button>
          </div>
          <div
            class="modal-body p-0 "
            id="play-youtube-video"
            v-if="tutorial.title !== ''"
          >
            <iframe
              style="width: 100%; height: 500px;"
              id="play-youtube-video-iframe"
              :src="'https://www.youtube.com/embed/' + tutorial.link"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="recordingModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="recordingModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="recordingModalTitle">Recordings</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
			  @click="removeChannelId"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
			  <div v-if="channel_id !== ''">
            	<ChannelRecordings :id="channel_id"></ChannelRecordings>
			  </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChannelRecordings from "./channel-recordings.vue";
export default {
  name: "dashboard",
  components: {
    ChannelRecordings,
  },
  data() {
    return {
      tutorial: {
        title: "",
      },
      tutorials: [],
      user: { is_admin: false },
      upcomingEvents: [],
      teams: [],
      events: [],
      quickEvents: [],
      counter: {
        invited: 0,
        registered: 0,
        attended: 0,
        meetFast: 0,
	  },
	  channel_id: ""
    };
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
    this.counters();
    this.eventList();
    this.getTutorials();
    this.quickEventList();
  },
  methods: {
	  setChannelId(id){
		  this.channel_id = id;
	  },
	  removeChannelId(){
		  this.channel_id = ''
	  },
    setTutorial(t) {
      this.tutorial = t;
    },
    closeTutorial() {
      this.tutorial = {
        title: "",
      };
    },
    dateTimeStamp(datePass) {
      var fullDate = new Date(datePass);
      var twoDigitMonth = fullDate.getUTCMonth() + "";
      if (twoDigitMonth.length == 1) twoDigitMonth = "0" + twoDigitMonth;
      var twoDigitDate = fullDate.getUTCDate() + "";
      if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
      var twoDigithour = fullDate.getUTCHours() + "";
      if (twoDigithour.length == 1) twoDigithour = "0" + twoDigithour;
      var twoDigitMin = fullDate.getUTCMinutes() + "";
      if (twoDigitMin.length == 1) twoDigitMin = "0" + twoDigitMin;
      // var currentDate = fullDate.getFullYear() + twoDigitMonth.getMonth() + twoDigitDate.getDate() + "T" + fullDate.getHours() + fullDate.getMonth() +"00"+ "z";
      var currentDate =
        fullDate.getUTCFullYear() +
        "" +
        twoDigitMonth +
        "" +
        twoDigitDate +
        "T" +
        twoDigithour +
        twoDigitMin +
        "00" +
        "Z";

      // console.log(currentDate);
      return currentDate;
    },
    counters: function() {
      this.$store.dispatch("getUserCounter").then((resp) => {
        if (resp.data.status === "success") {
          this.counter = resp.data.data;
        }
      });
    },
    eventList: function() {
      this.$store.dispatch("getUpcomingEvent").then((resp) => {
        if (resp.data.status === "success") {
          this.events = resp.data.data;
          this.events.forEach((x) => {
            x.calendar_start = this.dateTimeStamp(
              x.start_date + " " + x.start_time
            );
            x.calendar_end = this.dateTimeStamp(x.end_date + " " + x.end_time);
          });
        }
      });
    },
    quickEventList: function() {
      this.$store.dispatch("getQuickEvent").then((resp) => {
        if (resp.data.status === "success") {
          this.quickEvents = resp.data.data;
          this.quickEvents.forEach((x) => {
            const randomColor = Math.floor(Math.random() * 16777215).toString(
              16
            );
            x.color = "#" + randomColor;
          });
        }
      });
    },
    getTutorials: function() {
      this.$store.dispatch("getTutorials").then((resp) => {
        if (resp.data.status === "success") {
          this.tutorials = resp.data.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
[data-user]:before {
  content: attr(data-user);
  display: inline-block;
  font-size: 2.5em;
  width: 100%;
  line-height: 2.8em;
  text-align: center;
  vertical-align: middle;
  color: white;
}
.card-counter {
  box-shadow: 2px 2px 10px #000;
  margin: 5px;
  padding: 20px 10px;
  background-color: #fff;
  height: 100px;
  border-radius: 5px;
  transition: 0.3s linear all;
}

.card-counter:hover {
  box-shadow: 1px 1px 4px #626262;
  transition: 0.3s linear all;
}

.card-counter.primary {
  background-color: #121212;
  color: #fff;
}

.card-counter.danger {
  background-color: #121212;
  color: #fff;
}

.card-counter.success {
  background-color: #121212;
  color: #fff;
}

.card-counter.info {
  background-color: #121212;
  color: #fff;
}

.card-counter i {
  font-size: 5em;
  opacity: 0.2;
}

.card-counter .count-numbers {
  position: absolute;
  right: 35px;
  top: 20px;
  font-size: 32px;
  display: block;
}

.card-counter .count-name {
  position: absolute;
  right: 35px;
  top: 65px;
  font-style: italic;
  text-transform: capitalize;
  opacity: 0.5;
  display: block;
  font-size: 18px;
}
.data-scroll::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.modal-body {
    width: 500px !important;
}
</style>
